import { render, staticRenderFns } from "./BookHoterExtPost.vue?vue&type=template&id=6920bc3c&scoped=true&"
import script from "./BookHoterExtPost.vue?vue&type=script&lang=js&"
export * from "./BookHoterExtPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6920bc3c",
  null
  
)

export default component.exports